import './agenda-list-item.scss';
import React from 'react';

export const AgendaListItem = ({ item, resources }) => {
  const resource = resources.find((r) => r.id === item.calendarId) || {};
  return <div className='agenda-list-item'>
    <div className='description'>
      <div className='description-title'>
        {item.text}
      </div>
      <div className='description-resource'>
        {resource.text}
      </div>
    </div>
  </div>;
};
